export default __webpack_public_path__ + "static/media/project-list-quick-info.1efa6ddf.svg";